import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

type FiltersWrapperProps = {
  $showProductVariantsInHeader: boolean;
};

export const FiltersWrapper = styled.div<FiltersWrapperProps>(
  props => css`
    display: flex;
    flex-direction: column;
    row-gap: ${layout.measurements.spacing050};
    margin-bottom: ${props.$showProductVariantsInHeader
      ? layout.measurements.spacing050
      : layout.measurements.spacing100};

    ${media.mediumDown`
    ${props.$showProductVariantsInHeader &&
      css`
        margin: 0;
      `}
  `}
  `
);
